import LogoMark from "./LogoMark";

export default function Brand({ className = "", style }) {
  return (
    <a
      className={`nfw-brand ${className}`.trim()}
      href="/"
      style={style}
      aria-label="NewFW"
    >
      <span className="nfw-brand-mark">
        <LogoMark title="NewFW" />
      </span>
      <span className="nfw-brand-name">NewFW</span>
    </a>
  );
}
